var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit_wrap"},[_c('button',{staticClass:"submit_btn",class:_vm.btnObj.class,attrs:{"id":"submit_btn","type":"button","disabled":_vm.disable},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.btnObj.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }